<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card" *ngIf='order && order.length > 0'>
              
                <div *ngIf="paymode === 'Razorpay (All Card / Net Banking)' && order[0].payment_status === 'pending'">
                
                        <div class="row">
                          <div  >
                              <h2 style="color: #9b7544;     margin-left: 250px;">We have received your order. <br>
                                But your payment is incomplete.  </h2>
                              </div>
                        </div>
                        <div class="row">
                          <div  >
                           <button  style=" margin-left: 250px;"class="btn btn-success2"  (click)='updateShipMode(order[0].id)'> Click here to process as COD </button>
                          </div>
                        </div>
             
                </div>

            <div class="card-header">
              <div class="row" style="font-style: open sans; color:#9b7544">
                <div class="col-sm-4 col-lg-2 col-xl-2" >
                    <h5>Order No: {{orderno}}</h5>
                </div>
                <div class="col-sm-4 col-lg-2 col-xl-2">
                    <h5>Order Date: {{order[0].date}}</h5>
                </div>
                <div class="col-sm-4 col-lg-2 col-xl-2">
                    <h5>Order Amount: Rs.{{order[0].payable}}</h5>
                  </div>
                  <div class="col-sm-4 col-lg-2 col-xl-2">
                      <h5>Shipping Mode:{{order[0].shipping_mode}}</h5>
                    </div>
                    <div class="col-sm-4 col-lg-2 col-xl-2">
                        <h5>Payment Mode: {{order[0].payment_mode}}</h5>
                      </div>
                      <div class="col-sm-4 col-lg-2 col-xl-2" *ngIf="ostatus">
                          <div *ngFor=" let data of ostatus">
                                <h5 *ngIf="data.id == order[0].status_id ">Status: {{data.name}}</h5>
                          </div>
                         
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row" style="margin: 2%">
                <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6">
                  <div class="card" *ngIf="shippingaddress ">
                    <div class="card-header">
                      <h4 style="color: #cb983f; font-family: open sans"><strong>Shipping Address</strong></h4>
                    </div>
                    <div class="card-body">
                      <p>{{shippingaddress.add_l1}}</p>
                      <p>{{shippingaddress.add_l2}}</p>
                      <div class="row">
                          <div class="col">
                              <p>City: {{city}}</p>
                          </div>
                          <div class="col">
                              <p>State:{{state}}</p>
                            </div>
                            <div class="col">
                                <p> country: {{country}}</p>
                              </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p>Pin: {{shippingaddress.pin}}</p>
                            </div>
                            <div class="col">
                                <p>Contact: {{shippingaddress.phone}}</p>
                              </div>
                          </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 col-md-6 col-lg-6 col-xl-6">
                    <div class="card" *ngIf=" billingaddress ">
                    <div class="card-header">
                        <h4 style="color: #cb983f; font-family: open sans"><strong>Billing Address</strong></h4>
                      </div>
                      <div class="card-body">
                        <p>{{billingaddress.add_l1}}</p>
                        <p>{{billingaddress.add_l2}}</p>
                        <div class="row">
                            <div class="col">
                                <p>City: {{city}}</p>
                            </div>
                            <div class="col">
                                <p>State: {{state}}</p>
                              </div>
                              <div class="col">
                                  <p>Country: {{country}}</p>
                                </div>
                          </div>
                          <div class="row">
                            <div class="col">
                                <p>Pin: {{billingaddress.pin}}</p>
                            </div>
                            <div class="col">
                                <p>Contact: {{billingaddress.phone}}</p>
                              </div>
                          </div>
                      </div>
                    </div> 
                  </div>
             </div>
              <div class="row" style="margin: 2%; font-style: open sans">
                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <div class="card" *ngFor="let data of orderitem">
                      <div class="card-header">
                        <div class="row">
                          <div class="col-12 text-center">
                            <h4 style="font-style: open sans; color: #cb983f"><strong>Order Items</strong></h4>
                          </div>
                        </div>
                      </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-3 text-center ">
                                    <img class="img-thumbnail"  src="https://passport.petcart.in/images/prodimgs{{productimg['id'+data.sku]}}">
                                </div>
                              <div class="col-9">
                                  <p style="font-family: open sans; color:#9b7544; font-weight:bold; font-size:1.6em;"><strong>{{ data.product_name }}</strong></p>
                                  <div class="row">
                                      <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3 text-center">
                                          <p  style="font-size:1.25em; font-family: open sans; color:#000 ">  MRP Rs. {{data.mrp}}</p>
                                      </div>
                                      <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3 text-center">
                                          <p  style="font-size:1.25em; font-family: open sans; color:#000 "> Discount Rs. {{ (data.discount) * (data.quantity) }} </p>
                                      </div>
                                      <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3 text-center">
                                          <p  style="font-size:1.25em; font-family: open sans; color:#000 "> quantity. {{ data.quantity }} </p>
                                      </div>
                                      <div class="col-sm-4 col-md-3 col-lg-3 col-xl-3 text-center">
                                          <p  style="font-size:1.25em; font-family: open sans; color:#000 "> Payable Rs. {{ data.payable }} </p>
                                      </div>
                                    </div>
                                </div>
                              </div>
                        </div>
                      </div>
                    </div>
                </div>
               
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top:2%; margin-bottom: 2%" *ngIf='order'>
          <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
            <button class="btn btn-success btn-block" (click)="goForReorder(orderno)">Reorder</button>
          </div>
          <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
              <button class="btn btn-success3 btn-block" *ngIf="(!(order[0].status_id == 9 || order[0].status_id == 7 ))" 
              (click)="cancelOrder()">Cancel</button>
            </div>
            <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <button class="btn btn-secondary btn-block" routerLink="/manageprofile/order">Back To Order</button>    
              </div>
        </div>
    </div>
    
         
            
      
            
          
          